/* tslint:disable */
/* eslint-disable */

/**
 * AAA-Rating is an automatic, constantly updated creditworthiness rating system.
 */
export enum AaaRatingCategory {
  Aaa = 'AAA',
  Aa = 'AA',
  A = 'A',
  An = 'AN',
  B = 'B',
  C = 'C',
  NotRated = 'Not Rated'
}
